import React from 'react';
import { Link } from 'react-router-dom';

function HomePage() {
    const styles = {
        container: {
            maxWidth: '900px',
            margin: '0 auto',
            padding: '3rem 2rem'
        },
        title: {
            fontSize: '1.75rem',
            fontWeight: 600,
            marginBottom: '2.5rem',
            color: '#fff',
            letterSpacing: '-0.5px'
        },
        grid: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0'
        },
        card: {
            background: 'transparent',
            border: '1px solid #2d3748',
            borderRadius: '8px',
            padding: '1rem',
            margin: '0.5rem 0',
            transition: 'all 0.2s ease',
            cursor: 'pointer',
            textDecoration: 'none',
            color: 'inherit',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        },
        cardTitle: {
            fontSize: '1rem',
            fontWeight: 500,
            color: '#e0e0e0',
            transition: 'color 0.2s ease',
            margin: 0
        },
        cardDesc: {
            fontSize: '0.8rem',
            color: '#888',
            transition: 'color 0.2s ease',
            margin: 0,
            marginTop: '0.25rem'
        },
        arrow: {
            fontSize: '1rem',
            color: '#666',
            opacity: 0,
            transition: 'all 0.2s ease',
            transform: 'translateX(-5px)'
        }
    };

    const pages = [
        { path: '/rankings', title: 'Country Rankings', desc: 'How many fighters does each country have in the P4P top X? Who are they?' },
        { path: '/second', title: 'UFC Fights', desc: 'All UFC fights, sortable and filterable by fighter/event/date/outcome' },
        { path: '/outcomes', title: 'UFC Outcomes', desc: 'Proportion of decisions/(T)KO/submissions over time in the UFC' },
        { path: '/events', title: 'UFC Events', desc: 'Number of UFC events across years' },
        { path: '/odds', title: 'Odds', desc: 'UFC biggest mismatches - fights with the largest win probability gaps' },
        { path: '/rebounds', title: 'UFC Rebounds', desc: 'All officially published weight rebounds in the UFC' }
    ];

    return (
        <div style={styles.container}>
            <h1 style={styles.title}></h1>

        

            <div style={{ marginTop: '3rem', paddingTop: '2rem', fontSize: '0.9rem', lineHeight: '1.6', color: '#888' }}>
                <p>
                    Compilation of MMA-related statistics and interactive visualizations that are not available on major sources such as:
                </p>
                <ul style={{ margin: '10px 0', paddingLeft: '1.5rem' }}>
                    <li><a href="https://www.fightmatrix.com" style={{ color: '#0a66c2', textDecoration: 'none' }}>Fight Matrix</a></li>
                    <li><a href="https://www.sherdog.com" style={{ color: '#0a66c2', textDecoration: 'none' }}>Sherdog</a></li>
                    <li><a href="https://www.tapology.com" style={{ color: '#0a66c2', textDecoration: 'none' }}>Tapology</a></li>
                    <li><a href="https://www.ufc.com" style={{ color: '#0a66c2', textDecoration: 'none' }}>UFC Official</a></li>
                    <li><a href="https://en.wikipedia.org/wiki/Ultimate_Fighting_Championship" style={{ color: '#0a66c2', textDecoration: 'none' }}>Ultimate Fighting Championship (Wiki)</a></li>
                    <li><a href="https://en.wikipedia.org/wiki/List_of_UFC_champions" style={{ color: '#0a66c2', textDecoration: 'none' }}>List of UFC Champions (Wiki)</a></li>
                    <li><a href="https://en.wikipedia.org/wiki/UFC_rankings" style={{ color: '#0a66c2', textDecoration: 'none' }}>UFC Rankings (Wiki)</a></li>
                    <li><a href="https://en.wikipedia.org/wiki/List_of_UFC_events" style={{ color: '#0a66c2', textDecoration: 'none' }}>List of UFC Events (Wiki)</a></li>
                </ul>

                <p style={{ marginTop: '1rem' }}>
                    Complementary resources I found interesting:
                </p>
                <ul style={{ margin: '10px 0', paddingLeft: '1.5rem' }}>
                    <li><a href="https://linktr.ee/natelatshaw" style={{ color: '#0a66c2', textDecoration: 'none' }}>Nate Latshaw</a> (extensive fight insights on a more micro level)</li>
                    <li><a href="https://www.youtube.com/@PredictionTracker" style={{ color: '#0a66c2', textDecoration: 'none' }}>Prediction Tracker</a> (comparing public predictors, but in Youtube form and using manual extraction)</li>
                </ul>
                <div style={{ marginTop: '2rem', paddingTop: '2rem', borderTop: '1px solid #2d3748', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <a href="mailto:rhaedinculpini@gmail.com" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', textDecoration: 'none', transition: 'color 0.2s ease', color: '#888' }} onMouseEnter={(e) => e.currentTarget.style.color = '#0a66c2'} onMouseLeave={(e) => e.currentTarget.style.color = '#888'}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                            <polyline points="22,6 12,13 2,6"></polyline>
                        </svg>
                        <span>Contact</span>
                    </a>
                </div>
            </div>
        </div>
    );
}

export default HomePage;
